<template>
  <div>
    <nav-breadcrumb :menu="[{label: '已授信客户'}]"/>
    <el-row>
      <el-col class=" bg-purple">
        <div class="xzpadd10 of">
          <data-table
            :table-data="tableData"
            :columns="columns"
            :page.sync="page"
            :pageSize.sync="pageSize"
            :filters.sync="filters"
            :actions="actions"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "CustomerList",
      data(){
        return{
          columns:[
            {
              type: 'index'
            },
            {
              label: '客户姓名',
              field: 'c__customerName'
            },
            /*{
              label: '手机号',
              field: 'c__customerContactNo'
            },*/
            {
              label: '身份证号码',
              field: 'c__customerIC'
            },
            {
              label: '创建时间',
              field: 'c__createdDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD HH:mm:ss')
              }
            },
            {
              label: '操作',
              opts:[
                {
                  label: '查看',
                  class: 'el-icon-view',
                  clickHandler: (index, row)=> {
                    this.$router.push(
                      {
                        path: 'View',
                        query: {
                          customerId: row.c__customerId
                        }
                      }
                    )
                  }
                },
              ]
            }
          ],
          tableData: {
            count: 0,
            data: []
          },
          page: 1,
          pageSize: 20,
          actions: [
          ],
          filters: {
            labelWidth: '150px',
            form: {
              c__customerName:'',
              c__customerContactNo:'',
              c__customerIC:'',
              c__createdDate:[],
            },
            columns: [
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'c__customerName'
              },
              /*{
                label: '手机号',
                component: 'el-input',
                field: 'c__customerContactNo'
              },*/
              {
                label: '身份证号码',
                component: 'el-input',
                field: 'c__customerIC'
              },
              {
                label: '创建时间',
                component: 'date-range-picker',
                field: 'c__createdDate',
                op: ['gteq', 'lteq'],
                span: 12
              },
            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      mounted() {
        this.getData()

      },
      computed: {
        filterParams() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'c.createdDate',
            'xlist.sort.order': 'desc'
          }
        }
      },
      watch: {
        filterParams: function (newVal) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getFangCustomerList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.tableData = res.data
              }catch(e){

              }
            })

        },


      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/CustomerList.vue